import React from "react";


export const SettingButtons = () => {
    return (
        <div className="btns-area">
            <a className="open-walk-set">목표 걸음수 설정</a>
            <a className="open-traning-set">목표 운동 설정</a>
        </div>
    );
};
